<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardBody>
            <div class="row mb-3 mr-0 d-flex justify-content-end">
              <div class="col-3">
              </div>
              <div class="col-auto pr-0">
                <CButton v-if="permissions.expense_types.add" color="success" @click="createExpenseType()">
                  <CIcon :content="$options.addIcon" />{{ $t('button.create') }} {{ $t('expense_types.label') }}
                </CButton>
              </div>
            </div>
            <CDataTable
              :items="filteredItems"
              :fields="fields"
              :items-per-page="perPage"
              :itemsPerPageSelect="itemsPerPage"
              :tableFilter="tableFilter"
              :table-filter-value.sync="search"
              :loading="loading"
              addTableClasses="d-print-table table-dropdown-fix"
              hover
              sorter
              pagination
            >
              <template #options="{item}">
                <td>
                  <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle" @click="openOptions" type="button" data-toggle="dropdown">
                      {{ $t('button.options') }}
                    </button>
                    <div class="dropdown-menu">
                      <button v-if="permissions.expense_types.read" class="dropdown-item" type="button" @click="showExpenseType(item.id)">{{ $t('button.details') }}</button>
                      <button v-if="permissions.expense_types.edit" class="dropdown-item" type="button" @click="editExpenseType(item.id)">{{ $t('button.edit') }}</button>
                      <button v-if="permissions.expense_types.delete" class="dropdown-item" type="button" @click="deleteExpenseType(item.id)">{{ $t('button.delete') }}</button>
                    </div>
                  </div>
                </td>
              </template>
            </CDataTable>
        </CCardBody>  
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import listMixin from '../../mixins/list';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPlus } from '@coreui/icons';

export default {
  name: 'ExpenseTypes',
  mixins: [listMixin, localeMixin],
  addIcon: cilPlus,
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', label: i18n.t('fields.expense_type') },
        {
          key: 'options',
          label: i18n.t('button.options'),
          sorter: false,
          filter: false
        }
      ],
      you: null,
      tableFilter: {
        label: i18n.t('search'),
        placeholder: i18n.t('expense_types.search_placeholder'),
        lazy: false,
        external: true
      },
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    }),
    filteredItems() {
      return this.items.filter(i => {
        return i.name.toLowerCase().includes(this.search.toLowerCase());
      });
    }
  },
  mounted() {
    this.getExpenseTypes();
  },
  methods: {
    showExpenseType(id) {
      this.$router.push({ name: 'ExpenseType', params: {id} });
    },
    editExpenseType(id) {
      this.$router.push({ name: 'EditExpenseType', params: {id} });
    },
    deleteExpenseType (id) {
      this.$swal({
        title: i18n.t('expense_types.modal.delete_label'),
        text: i18n.t('expense_types.modal.delete_body'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: i18n.t('button.accept')
      }).then(result => {
        if (result.value) {
          // do delete request
          axios.delete('/api/expense-types/'+ id + '?token=' + localStorage.getItem("api_token"))
          .then(response => {
            this.$swal(
              i18n.t('expense_types.modal.deleted_label'),
              i18n.t('expense_types.modal.delete_body'),
              'success'
              );
              this.getExpenseTypes();
          });
        }
      });
    },
    createExpenseType () {
      this.$router.push({ name: 'CreateExpenseType' });
    },
    getExpenseTypes() {
      this.loading = true;
      axios.get('/api/expense-types?token=' + localStorage.getItem("api_token"))
      .then(response => {
        this.items = response.data;
        this.loading = false;
      }).catch(error => {
        console.log(error);
        this.$router.push({ path: '/login' });
      });
    }
  }
}
</script>

